import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { HeroSection } from './components/HeroSection';
import { EarlyTestimonials } from './components/EarlyTestimonials';
import { HowItWorks } from './components/HowItWorks';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { AuthorSection } from './components/AuthorSection';
import { FeaturesSection } from './components/FeaturesSection';
import { MidPageCTA } from './components/MidPageCTA';
import { BundleVisual } from './components/BundleVisual';
import { BonusSection } from './components/BonusSection';
import { FAQSection } from './components/FAQSection';
import { MoneyBackGuarantee } from './components/MoneyBackGuarantee';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <div className="w-full min-h-screen bg-stone-50" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <HeroSection data-id="element-2" />
      <EarlyTestimonials data-id="element-3" />
      <HowItWorks data-id="element-4" />
      <ProblemSection data-id="element-5" />
      <MechanismSection data-id="element-6" />
      <AuthorSection data-id="element-7" />
      <FeaturesSection data-id="element-8" />
      <MidPageCTA data-id="element-9" />
      <BundleVisual data-id="element-10" />
      <BonusSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <MoneyBackGuarantee data-id="element-13" />
      <WhoIsThisFor data-id="element-14" />
      <FinalCTA data-id="element-15" />
    </div>;
}